export default __webpack_public_path__ + "static/Infinity-2db5d2541243b8fe8d2d0c1becc3b9d8.gif";